import { QSScholarship, QSSkillPassport, QSAttendance, QSCareerPlacement } from "../assets/index.jsx";
import { getPortalSelectionAppUrl, ISUAT } from "../services";

export const featureSelectionConfig = (t, isSkipTranslation = false) => [
  {
    key: "scholarship",
    // title: isSkipTranslation ? "Scholarship" : (t ? t("portal_selection.scholarship", "Scholarship") : "Scholarship"),
    subtitle: "Explore scholarship opportunities and track your applications.",
    config: {
      img: QSScholarship,
      icon: "material-symbols:school",
    },
    path: getPortalSelectionAppUrl('scholarship', ''),
    enabled: true,
    comingSoon: true,
    color: "#7c3aed",
    bg: "rgba(124, 58, 237, 0.10)",
  },
  {
    key: "skillPassport",
    // title: isSkipTranslation ? "Skill Passport" : (t ? t("portal_selection.skill_passport", "Skill Passport") : "Skill Passport"),
    subtitle: "Manage your skills, showcase achievements, and access your skill credentials.",
    config: {
      img: QSSkillPassport,
      icon: "solar:chart-2-bold",
    },
    path: getPortalSelectionAppUrl('skillPassport', ''),
    enabled: true,
    color: "#ea580c",
    bg: "rgba(234, 88, 12, 0.10)",
  },
  {
    key: "attendance",
    // title: isSkipTranslation ? "Attendance" : (t ? t("portal_selection.attendance", "Attendance") : "Attendance"),
    subtitle: "	View and monitor your attendance records and track attendance progress.",
    config: {
      img: QSAttendance,
      icon: "material-symbols:grid-view",
    },
    path: getPortalSelectionAppUrl('attendance', ''),
    enabled: true,
    color: "#16a34a",
    bg: "rgba(22, 163, 74, 0.10)",
  },
  {
    key: "internshipAndPlacement",
    // title: isSkipTranslation ? "Internship & Placement" : (t ? t("portal_selection.internship_and_placement", "Internship & Placement") : "Internship & Placement"),
    subtitle: "Explore career opportunities, internships, and placement services.",
    config: {
      img: QSCareerPlacement,
      icon: "solar:case-round-minimalistic-bold",
    },
    path: getPortalSelectionAppUrl('placementManagement', '/job-opportunities'),
    enabled: true,
    comingSoon: ISUAT ? true : false,
    color: "#2563eb",
    bg: "rgba(37, 99, 235, 0.10)",
  },
  {
    key: "feedback",
    // title: isSkipTranslation ? "Feedback" : (t ? t("portal_selection.feedback", "Feedback") : "Feedback"),
    subtitle: "Share feedback, submit suggestions, and access the feedback portal.",
    path: getPortalSelectionAppUrl("feedback", ""),
    enabled: true,
    color: "#0D9488",
    bg: "rgba(13, 148, 136, 0.10)",
  },
];

export default featureSelectionConfig;
